import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InitialState {
  isTagReviewModalOpen: boolean;
  channelId?: string;
  groupId?: string;
  messageId?: string;
}

const initialState: InitialState = {
  isTagReviewModalOpen: false,
};

type OpenModalPayload = {
  channelId?: string;
  groupId?: string;
  messageId?: string;
};

export const documentTagReviewModal = createSlice({
  name: "documentTagReviewModal",
  initialState,
  reducers: {
    openDocumentTagReviewModal: (
      state,
      action: PayloadAction<OpenModalPayload>
    ) => {
      state.isTagReviewModalOpen = true;
      state.channelId = action.payload.channelId;
      state.groupId = action.payload.groupId;
      state.messageId = action.payload.messageId;
    },

    closeDocumentTagReviewModals: (state) => {
      state.isTagReviewModalOpen = false;
    },
  },
});

export const { openDocumentTagReviewModal, closeDocumentTagReviewModals } =
  documentTagReviewModal.actions;

export default documentTagReviewModal.reducer;
